export default __webpack_public_path__ + "./images/nf.a421f19d.png";